//@ts-nocheck
import React from 'react'
import cbModal from '../../../../Modal/Modal'
import { insertImage } from './Modal/ModalComponent';

import ImageModal from './Modal'
import UploadModal from './Modal/UploadModal'

import './style.module.css'

export const imageHandleMouseDown = (e, editor) => {
  e?.preventDefault();

  const state = new editor.TextareaState(editor.panels)

  const CustomModal = editor.customChooseFromAssetsModal;
  if (CustomModal && (typeof CustomModal === 'function' || typeof CustomModal === 'object')) {
    return cbModal({
      component: (props) => (
        <CustomModal 
          editor={editor} 
          state={state}
          insertImage={(url) => insertImage({editor, url, state})}
          {...props}
        />
      ),
      modalProps: {
        size: 'max',
        shouldReturnFocusAfterClose: false,
        customClass: 'AssetFieldModal-wide-popup V2-select-wide-popup'
      },
    })
  }

  if(editor.useV2EmbedPicker && editor?.showImageEmbedModal){
    return editor.showImageEmbedModal()
  }

  cbModal({
    component: (props) => <ImageModal editor={editor} state={state} {...props} />,
    modalProps: {
      size: 'max',
      shouldReturnFocusAfterClose: false,
      onClose: () => { }
    },
  })
}

export const uploadImageHandleMouseDown = (e, editor) => {
  e?.preventDefault();

  const state = new editor.TextareaState(editor.panels)

  if (typeof editor.openAMV2UploadTarget === 'function') {
    editor.openAMV2UploadTarget(editor, state)
    return
  }

  cbModal({
    component: (props) => <UploadModal editor={editor} state={state} {...props} />,
    modalProps: {
      size: 'max',
      shouldReturnFocusAfterClose: false,
      onClose: () => { }
    },
  })
}